/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UsesType {
    Unlimited = 'Unlimited Use',
    PerUse = 'Per Use',
    AcrossTheBoard = 'Across The Board',
}
